export default __webpack_public_path__ + "static/media/1@2x.f9b3b4e5.png";